export default __webpack_public_path__ + "static/media/newlog.be7f0352.png";